
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/winners",
      function () {
        return require("private-next-pages/winners/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/winners"])
      });
    }
  